// assets/wishlist.js
(() => {
  const STORAGE_KEY = "tf_wishlist";

  const read = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch {
      return [];
    }
  };

  const updateWishlistQty = (handles) => {
    const count = Array.isArray(handles) ? handles.length : read().length;
    const els = document.querySelectorAll(".wishlist-qty");

    els.forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";

      // optional bump animation if you add CSS .wishlist-qty.is-bump
      el.classList.remove("is-bump");
      // force reflow
      void el.offsetWidth;
      el.classList.add("is-bump");
    });
  };

  const write = (handles) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));

    // update header badge immediately
    updateWishlistQty(handles);

    // notify all components
    window.dispatchEvent(
      new CustomEvent("wishlist:changed", { detail: { handles } })
    );
  };

  const has = (handle) => read().includes(handle);

  const add = (handle) => {
    if (!handle) return;
    const list = read();
    if (!list.includes(handle)) list.unshift(handle);
    write(list);
  };

  const remove = (handle) => {
    if (!handle) return;
    write(read().filter((h) => h !== handle));
  };

  const toggle = (handle) => (has(handle) ? remove(handle) : add(handle));

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;

      this.handle = this.dataset.handle;
      this.link = this.querySelector("a");
      this.iconEl = this.querySelector("[data-wishlist-icon]");
      this.tooltipEl = this.querySelector("[data-wishlist-tooltip]");
      this.itemEl = this.closest("[data-wishlist-item]") || this.closest("li");

      if (!this.handle || !this.link) return;

      this.tooltipAdd = this.dataset.tooltipAdd || "Add To Wishlist";
      this.tooltipRemove = this.dataset.tooltipRemove || "Remove Wishlist";
      this.iconAdd = this.dataset.iconAdd || "icon-heart-2";
      this.iconRemove = this.dataset.iconRemove || "icon-trash";

      this.onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(this.handle);
        this.render();
      };

      this.onChanged = () => this.render();

      this.link.addEventListener("click", this.onClick);
      window.addEventListener("wishlist:changed", this.onChanged);

      this.render();
    }

    disconnectedCallback() {
      if (this.link) this.link.removeEventListener("click", this.onClick);
      window.removeEventListener("wishlist:changed", this.onChanged);
    }

    render() {
      const active = has(this.handle);

      // 1) toggle class addwishlist on LI like your examples
      if (this.itemEl) this.itemEl.classList.toggle("addwishlist", active);

      // 2) swap icon class
      if (this.iconEl) {
        this.iconEl.classList.remove(this.iconAdd, this.iconRemove);
        this.iconEl.classList.add(active ? this.iconRemove : this.iconAdd);
      }

      // 3) swap tooltip text
      if (this.tooltipEl) {
        this.tooltipEl.textContent = active ? this.tooltipRemove : this.tooltipAdd;
      }

      // 4) a11y
      this.link.setAttribute("aria-pressed", active ? "true" : "false");
      this.link.setAttribute("aria-label", active ? this.tooltipRemove : this.tooltipAdd);
    }
  }

  if (!customElements.get("wishlist-button")) {
    customElements.define("wishlist-button", WishlistButton);
  }

  // expose (optional)
  window.TFWishlist = { read, write, has, add, remove, toggle };

  // init qty on load
  updateWishlistQty(read());

  // sync when returning to tab (or bfcache restore)
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) updateWishlistQty(read());
  });
})();
